import React, { memo } from 'react';
import { LazySuspense, lazyForPaint } from 'react-loosely-lazy';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { COMPONENT_NAME, ANALYTICS_CHANNEL } from '../common/constants';
import { name as packageName, version as packageVersion } from '../version.json';
import ErrorBoundary from './error-boundary';
import { ErrorBoundaryFallback } from './error-boundary-fallback';
import { LoaderFallback } from './loader-fallback';
export const PACKAGE_DATA = {
  packageName,
  packageVersion,
  componentName: COMPONENT_NAME,
  source: COMPONENT_NAME
};
const LazyLinkPicker = lazyForPaint(() => import(
/* webpackChunkName: "@atlaskit-internal_link-picker" */
'./link-picker'));
export const ComposedLinkPicker = /*#__PURE__*/memo(props => /*#__PURE__*/React.createElement(AnalyticsContext, {
  data: PACKAGE_DATA
}, /*#__PURE__*/React.createElement(ErrorBoundary, {
  channel: ANALYTICS_CHANNEL,
  ErrorComponent: ErrorBoundaryFallback
}, /*#__PURE__*/React.createElement(LazySuspense, {
  fallback: LoaderFallback
}, /*#__PURE__*/React.createElement(LazyLinkPicker, props)))));